import { initializeApp } from 'firebase/app'

// Add the Firebase services that you want to use
import 'firebase/firestore'

// Web app's Firebase configuration
const dataFirebaseConfig = {
    apiKey: process.env.REACT_APP_FB_API_KEY,
    authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FB_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FB_APP_ID
}

// Initialize Firebase
export const dataFB = initializeApp(dataFirebaseConfig)
